import React from "react";
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core"
import { ExpandMore } from "@material-ui/icons";

export default function PreviewData({ open, openHandler, data, dataHandler }) {
    return <Dialog
        open={open}
        onClose={() => {
            openHandler(false)
            dataHandler(null)
        }}
        fullWidth
        scroll="paper"
    >
        <DialogTitle>
            <DialogHeader level={data.level} appName={data.appName} machineName={data.machineName} />
        </DialogTitle>
        <DialogContent dividers>
            <Grid container direction="column" style={{ gap: "16px" }}>
                <Grid container style={{ gap: "8px" }}>
                    <Grid container direction="row" justifyContent="space-between">
                        <DialogInfo header="ID" data={data.id} />
                        <DialogInfo header="Date" data={data.date} />
                    </Grid>
                    <Grid container direction="row" justifyContent="space-between">
                        <DialogInfo header="Class Name" data={data.className} />
                        <DialogInfo header="Member Name" data={data.memberName} />
                    </Grid>
                </Grid>
                <Grid container>
                    <DialogDetails header="Message" data={data.message} />
                    <DialogDetails header="Exception" data={data.exception} />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="primary" size="small" onClick={() => openHandler(false)}>
                Close
            </Button>
        </DialogActions>
    </Dialog>
}

function DialogHeader({ level, appName, machineName }) {
    return <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item>
            <Typography variant="h6">
                {level.toUpperCase()} {appName && `on ${appName}`}
            </Typography>
            {machineName && <Typography variant="subtitle2">
                {machineName}
            </Typography>}
        </Grid>
    </Grid>
}

function DialogInfo({ header, data }) {
    return <>
        {data && <Grid item sm={6}>
            <Typography variant="subtitle2" style={{ fontSize: "13px" }}>{header}</Typography>
            {data && <Typography variant="body2" style={{ fontSize: "15px" }}>{data}</Typography>}
        </Grid>}
    </>
}

function DialogDetails({ header, data }) {
    return <>
        {data && <Accordion square style={{ width: "100%" }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle2">{header}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography variant="body2" paragraph style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {data}
                </Typography>
            </AccordionDetails>
        </Accordion>}
    </>
}